import { Component } from '@angular/core';
import { FlexLayoutModule } from "@ngbracket/ngx-layout";
import { ForgeCardModule } from "@tylertech/forge-angular";

@Component({
    selector: 'unsupported-browser',
    imports: [
        FlexLayoutModule,
        ForgeCardModule,
    ],
    template: `<forge-card>
    <div class="browser-dialog">
        <div>
            <img src="https://cdn.forge.tylertech.com/v1/images/spot-hero/unsupported-browser-error-spot-hero.svg"
                alt="Illustration of an outdated computer.">
        </div>

        <div style="margin-top: 64px;">
            <h2>Vintage is cool, but it's time for an upgrade.</h2>
        </div>

        <div style="height:100%">
            For the best user experience, we recommend a modern browser (Chrome, FireFox, Safari or
            Edge)
        </div>
    </div>

    <div fxLayout="row" fxLayoutAlign="end center">
        <button mat-button matDialogClose telemetry="Submission-Dismiss">
            Dismiss
        </button>
    </div>
  </forge-card>`,
    styles: ``,
})
export class UnsupportedBrowserComponent
{

}
